import React from 'react'
import ReactDOM from 'react-dom/client'
import { ClerkProvider, useAuth } from '@clerk/clerk-react'
import { SWRConfig } from 'swr'
import App from './App'
import './styles/globals.css'

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || 'pk_test_mock'

function AppWithSWR() {
  const { getToken, isSignedIn, isLoaded } = useAuth()

  const fetcher = async (resource: string, init?: RequestInit) => {
    // Wait for Clerk to load
    if (!isLoaded) {
      throw new Error('Authentication is loading...')
    }

    // Check if user is signed in
    if (!isSignedIn) {
      throw new Error('User is not signed in')
    }

    const token = await getToken()

    // If no token, throw error
    if (!token) {
      throw new Error('Failed to get authentication token')
    }

    const res = await fetch(resource, {
      ...init,
      headers: {
        ...init?.headers,
        Authorization: `Bearer ${token}`,
      },
    })
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}: ${res.statusText}`)
    }
    return res.json()
  }

  return (
    <SWRConfig
      value={{
        fetcher,
        revalidateOnFocus: false,
        shouldRetryOnError: false
      }}
    >
      <App />
    </SWRConfig>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPubKey}>
      <AppWithSWR />
    </ClerkProvider>
  </React.StrictMode>
)
